import createRoutes from './component.jsx'

export default createRoutes
